/*
 *
 * UserAction constants
 *
 */

enum ActionTypes {
  SAVE_FURNITURE_REQUEST = 'app/CONFIGURATOR/USER_ACTIONS/SAVE_FURNITURE_REQUEST',
  SAVE_FURNITURE_SUCCESS = 'app/CONFIGURATOR/USER_ACTIONS/SAVE_FURNITURE_SUCCESS',
  SAVE_FURNITURE_FAILURE = 'app/CONFIGURATOR/USER_ACTIONS/SAVE_FURNITURE_FAILURE',
  RESET_SAVEMODE = 'app/CONFIGURATOR/USER_ACTIONS/RESET_SAVEMODE',
}

export enum SaveMode {
  AddToCart = 'AddToCart',
  Print = 'Print',
  AddToCurrentOrder = 'AddToCurrentOrder',
  SaveForLater = 'SaveForLater',
  Export = 'Export',
}

export default ActionTypes;
